const module = { name: 'movie/shared/mobile/headerUI', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_movieDetails } from 'require-core';

const { movieDetails: { id } } = Fandango_movieDetails;


import { default as cast } from 'swug-fdRequire-call:movie/shared/mobile/cast';



import { default as details } from 'swug-fdRequire-call:movie/shared/details';



import { default as heartsUI } from 'swug-fdRequire-call:movie/shared/heartsUI';



import { default as imgCarousel } from 'swug-fdRequire-call:movie/shared/mobile/carousel';



import { default as rottenTomatoesRating } from 'swug-fdRequire-call:shared/utils/rottenTomatoesRating';

function attachMediaCarousel(id) {
    imgCarousel.attach({
        id,
        cellTemplate: '_imgGalleryScroll'
    }, details.attach);
}
function attach() {
    rottenTomatoesRating.attach();
    cast.attach();
    heartsUI.attach();
    attachMediaCarousel(id);
}
module.exports = {
    attach
};
export default module.exports;